import Service from "./Service";
import {
  ExtraInfoEntity,
  InsuranceProductEntity,
  PolicyEntity,
  PolicyInfoEntity,
  PolicyThrowEntity,
  ProductInfoEntity,
  RobotInfoEntity,
  SpecInfoEntity,
  ThrowInfoEntity,
} from "../model/InsurancePolicy";
class insurancePolicyService extends Service {
  getInsuranceMatching(data: PolicyThrowEntity) {
    return this.post<PolicyThrowEntity>(`/PolicyThrow/InsuranceMatching`, data);
  }
  getProductInfo(data: ProductInfoEntity) {
    return this.post<ProductInfoEntity>("/PolicyInfo/productInfo", data, { failTips: false });
  }
}

export default new insurancePolicyService("insurancePolicy");
